import { Box, Button, CircularProgress, Divider, Stack } from "@mui/material";
import React from "react";
import { PresignFileType } from "../../../../services/api/types/portalConfiguration/uploadPhoto";
import { FormErrors, FormValues } from "../AssignmentUploads";
import { UploadFile } from "./UploadFile";
import { VersionDetails, VersionField } from "./VersionDetails";
import { brand } from "../../../../theme/themePrimitives";

interface UploadSectionProps {
  setShowUploadSection: React.Dispatch<React.SetStateAction<boolean>>;
  formValues: FormValues;
  errors: FormErrors;
  handleFileUpload: (file: File | null, type: PresignFileType) => void;
  onVersionChange: (field: VersionField, value: string) => void;
  loading: boolean;
  thumbnailUploading: boolean;
  buttonLoading: boolean;
  handleSave: () => void;
}

export const UploadSection: React.FC<UploadSectionProps> = ({
  setShowUploadSection,
  formValues,
  errors,
  handleFileUpload,
  onVersionChange,
  loading,
  thumbnailUploading,
  buttonLoading,
  handleSave,
}) => {
  return (
    <Box>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "500px",
          }}
        >
          <CircularProgress size={100} />
        </Box>
      ) : (
        <>
          <Box width={"100%"} mb={2}>
            <UploadFile
              value={formValues.packageFile}
              onChange={(file) =>
                handleFileUpload(file, PresignFileType.PACKAGE)
              }
              error={errors.packageFile}
              label="Upload package"
              mode="package"
              packageType={formValues.packageType}
            />
          </Box>
          <Box width={"100%"}>
            <VersionDetails
              version={formValues.version}
              note={formValues.note}
              onChange={onVersionChange}
              versionError={errors.version}
              noteError={errors.note}
            />
          </Box>
          <Divider sx={{ mb: 4, mt: 5 }} />
          <Box width={"100%"} mb={4}>
            <UploadFile
              value={formValues.thumbnailFile}
              onChange={(file) =>
                handleFileUpload(file, PresignFileType.PACKAGE_THUMBNAIL)
              }
              error={errors.thumbnailFile}
              uploading={thumbnailUploading}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setShowUploadSection(false)}
            >
              Go back
            </Button>
            {buttonLoading ? (
              <CircularProgress />
            ) : (
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: `${brand[600]} !important`,
                  color: `white`,
                  "&:hover": {
                    backgroundColor: `${brand[700]} !important`,
                  },
                }}
                onClick={handleSave}
              >
                Save assignment
              </Button>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};
